import { Translatable } from "@icc/shared/helpers";

/** Zaślepki wierceń prowadnic */
export class GuideDrillingCap {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    @Translatable({ model: 'WindowAccessories' })
    name: string;
    /** Liczba zaślepek wierceń */
    amount: number;
    /** Waga */
    weight?: number;
    /** Kolejność */
    order: number;
}

export interface IccGuideDrillingCap {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    name: string;
    /** Waga */
    weight?: number;
    /** Kolejność */
    order: number;
}
